import { __ } from '@wordpress/i18n';
import {
	TextControl,
} from '@wordpress/components';
import ColorControl from '../../../controls/ColorControl';
const Award = ({ item, index, itemIndex, handleChangeItemField, setAttributes, attributes }) => {
	
	const {
		awardNameColor,
		awardArrowColor,
		style,
	} = attributes || {};
	
	return (
		<>
			<TextControl
				label={__('Title', 'cv-builder')}
				value={item.name || ''}
				onChange={(value) =>
					handleChangeItemField(value, index, itemIndex, 'name')
				}
			/>
			{style !== 'style26' && style !== 'style27' && style !== 'style28' && (
				<>
					<ColorControl
						label={__(
							'Award Name Color',
							'cv-builder'
						)}
						color={awardNameColor}
						colorName="awardNameColor"
						onChange={(colorObj) => setAttributes(colorObj)}
					/>
					<ColorControl
						label={__(
							'Arrow Color',
							'cv-builder'
						)}
						color={awardArrowColor}
						colorName="awardArrowColor"
						onChange={(colorObj) => setAttributes(colorObj)}
					/>
				</>
			)}
		</>
	);
};

export default Award;
